import { data } from '@amazon/vinyl-observable'

export const nerdStatsVisible = data(false)

export function toggleNerdStats() {
    nerdStatsVisible.value = !nerdStatsVisible.value
}
